import { Outlet } from 'react-router-dom';

import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';
import { useCurrentUserTaskWasUpdatedToast } from '@sorare/gameplay/src/hooks/useCurrentUserTaskWasUpdatedToast';

const Layout = () => {
  useCurrentUserTaskWasUpdatedToast();

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};

export default Layout;
